import React, { useEffect, useState } from "react";
import { apiCallResponse } from "src/_apiConfig/apiCall";

import { TableHeader } from "../common/Table/TableHeaderLabel";
import { FilterContainsInsensitive } from "../common/FilterCondition";
import DropDownDisctrict from "../common/controller/DropDown/Disctrict";
import {
  CommonSearchExtra,
  SCAddButton,
  SCInput,
  updateSearchStatus,
} from "../common/CommonSearch";
import Auth from "src/auth";
import CommonList from "../common/CommonList";

const DistrictList = () => {
  const { authenticated } = Auth();
  const [usersData, setuserData] = useState([]); // List data manage
  const [pageCount, setPageCount] = useState(0); // List Data pagging manage
  const [loading, setloading] = useState(false); // page loading
  const [pageLimit, setpageLimit] = useState(0); // pageing index manage
  const [itemPerPage, setItemPerPage] = useState(10); // Record Show Each Page
  const [disabledprev, setdisabledprev] = useState(false); //Pagging Prev. Button disabled manage;
  const [disablednext, setdisablednext] = useState(false); //Pagging Next Button disabled manage;
  const [isSearch, setIsSearch] = useState(false); // Search Button Effect Manage
  const [isClear, setIsClear] = useState(false); // Clear Button Effect Manage
  const [textField, settextField] = useState("name"); // table header Default Selected Column
  const [order, setorder] = useState("asc"); // table header Default Selected Column order Set
  const [orderClick, setOrderClick] = useState(true); // table header orderClick Column manage

  // Your default search model
  const SearchFilterModel = {
    disctrict: "",
    desc: "",
  };

  const [search, setSearch] = useState(SearchFilterModel); // Search Manage

  useEffect(() => {
    setloading(true);
    resetPageLimit(0);
    getPageCount();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  useEffect(() => {
    if (isSearch === false) {
      getDistrictList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, pageLimit, textField, orderClick]);

  useEffect(() => {
    if (isSearch) {
      getPageCount();
      getDistrictList();
      setIsClear(false);
      setIsSearch(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearch, itemPerPage]);

  // useEffect(() => {
  //   orderClick ? setorder("asc") : setorder("desc");
  //   getDistrictList(true);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [pageLimit, textField, orderClick, itemPerPage]);

  // pagging Disabled  manage
  const paggingDisabled = (isNext = true, isPrev = true) => {
    setdisablednext(isNext);
    setdisabledprev(isPrev);
  };
  // pagging Manage
  const paggingDisabledManage = (totalRecord) => {
    setPageCount(parseInt(totalRecord) || 0);
    paggingDisabled(
      pageLimit >= parseInt(totalRecord) - parseInt(itemPerPage),
      pageLimit === 0
    );
  };

  // Filter paramater Value manage for API
  const filterManage = () => {
    let filter = "";

    filter = "&$filter=";

    filter = FilterContainsInsensitive(filter, "name", search.disctrict);
    filter = FilterContainsInsensitive(filter, "desc", search.desc);
    // if (circleMsearch !== "" && circleMsearch !== undefined) {
    //   if (filter !== "&$filter=") {
    //     filter += " and ";
    //   }
    //   filter += "contains(circle_Masters,'" + circleMsearch + "')";
    // }

    // if (userDistsearch !== "" && userDistsearch !== undefined) {
    //   if (filter !== "&$filter=") {
    //     filter += " and ";
    //   }
    //   filter += "contains(user_Districts,'" + userDistsearch + "')";
    // }

    if (filter === "&$filter=") {
      filter = "";
    }
    return filter;
  };

  const getPageCount = async () => {
    if (authenticated) {
      await apiCallResponse(`District_Master?${filterManage()}`).then((res) => {
        if (res.success) paggingDisabledManage(parseInt(res.data.length) || 0);
      });
    }
  };
  const getDistrictList = async () => {
    paggingDisabled();
    setloading(true);

    await apiCallResponse(
      `District_Master?$orderBy=${textField}%20${order}&$skip=${pageLimit}&$top=${Number(
        itemPerPage
      )}${filterManage()}`
    ).then((res) => {
      if (res.success) {
        setuserData(res.data);
        if (isSearch === false && pageLimit >= 0 && pageCount > 0) {
          paggingDisabledManage(pageCount);
        }
      }
      setloading(false);
    });
  };

  const resetPageLimit = (pageLimit) => {
    setpageLimit(pageLimit || 0);
  };

  // Search Model Value Update Manage
  const updateSearch = (e, name = "", value = "") => {
    updateSearchStatus(setSearch, search, e, name, value);
  };
  // item per page  onChanage Event
  const onChangePage = (ev) => {
    ev.preventDefault();
    resetPageLimit();
    setItemPerPage(ev.target.value);
    setIsSearch(true);
  };

  // Search Button Click Event
  const searchButton = (ev) => {
    ev.preventDefault();
    resetPageLimit();
    setIsSearch(true);
  };
  // Clear Button Click Event
  const clearSearchButton = (ev) => {
    ev.preventDefault();
    resetPageLimit();
    setIsClear(true);
    setIsSearch(true);
    setSearch({ ...search, ...SearchFilterModel });
    setuserData();
  };

  // Pagging Prev. Button Click Event
  const prevButton = () => {
    let pageLimitSet = parseInt(pageLimit) - parseInt(itemPerPage);
    pageLimitSet = pageLimitSet < 0 ? 0 : pageLimitSet;
    resetPageLimit(pageLimitSet);
  };
  // Pagging Next Button Click Event
  const nextButton = () => {
    let pageLimitSet = parseInt(pageLimit) + parseInt(itemPerPage);
    pageLimitSet =
      pageLimitSet >= parseInt(pageCount) ? parseInt(pageCount) : pageLimitSet;
    resetPageLimit(pageLimitSet);
  };
  const searchControl = (
    <>
      <DropDownDisctrict
        isClear={isClear}
        isValueLabelSame={true}
        name={"disctrict"}
        value={search.disctrict}
        onChange={updateSearch}
      />
      <SCInput
        label={"Description:"}
        name={"desc"}
        value={search.desc}
        onChange={updateSearch}
      />
    </>
  );
  let additional = (
    <CommonSearchExtra
      isDisabledSearchClear={loading}
      extraControl={searchControl}
      search={search}
      updateSearch={updateSearch}
      searchButton={searchButton}
      clearSearchButton={clearSearchButton}
      itemPerPage={itemPerPage}
      onChangePage={onChangePage}
      extraSearchControl={<SCAddButton tourl={"/adddistrict"} />}
    />
  );

  const thClick = (ev, getTextField) => {
    ev.preventDefault();
    setOrderClick(!orderClick);
    if (textField !== getTextField) {
      setorder("asc");
    } else {
      !orderClick ? setorder("asc") : setorder("desc");
    }
    resetPageLimit();
    settextField(getTextField);
  };
  //table Header Set
  const TableHeaderSet = (labelValue, getTextField) => {
    return TableHeader(labelValue, getTextField, thClick, textField, order);
  };
  const fields = [
    {
      key: "name",
      _style: { width: "30%" },
      label: TableHeaderSet("District Union", "name"),
    },
    {
      key: "desc",
      _style: { width: "30%" },
      label: TableHeaderSet("Description", "desc"),
    },

    {
      key: "EditionInRow",
      _style: { width: "30%" },
      label: TableHeaderSet("Status", "status"),
    },
    {
      key: "show_details",
      label: "Edit",
      _style: { width: "1%" },
      sorter: false,
      filter: false,
    },
  ];

  return (
    <CommonList
      items={usersData}
      fields={fields}
      listName="District Union List"
      loading={loading}
      path={`/editdistrict/`}
      tabBtn="Edit"
      prev={prevButton}
      next={nextButton}
      disabledprev={disabledprev}
      disablednext={disablednext}
      additional={additional}
      id="districtId"
    />
  );
};
export default DistrictList;
